<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            退费审核
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                        <el-button type="primary" :disabled="disabledAdd"  @click.native="toggleModalAdd">通过</el-button>
                        <el-button type="success" :disabled="disabledEdit" @click="toggleModalEdit">不通过</el-button>
                    
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column prop="elderlyName" label="姓名"></el-table-column>

                        <el-table-column prop="returnBalance" label="退款金额（元）"></el-table-column>

                        <el-table-column prop="auditResult"  label="审核状态">
                            <template slot-scope="scope">
                                    <el-tag type="primary"  v-show="scope.row.auditResult==0" effect="plain">未审核</el-tag>
                                    <el-tag type="success"  v-show="scope.row.auditResult==1" effect="plain">已通过</el-tag>
                                    <el-popover
                                        placement='right'
                                        title="备注"
                                        width="200"
                                        trigger="hover"
                                        :content="scope.row.noPassCause?scope.row.noPassCause:'无备注'">
                                        <el-tag type="danger"  slot="reference"  v-show="scope.row.auditResult==2" effect="plain">未通过</el-tag>
                                    </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remarks"  label="备注"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="登记时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                row:null,
                elderlyName:'',
                menuButtonList:null,
                disabledAdd:true,
                disabledEdit:true,
                showModalAdd:false,
                showModalEdit:false,
                searchBuild:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,

            }
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                console.log(this.menuButtonList)
                // if(menu!=null&&menu.length>0){
                //     for(let i=0;i<menu.length;i++){
                //         if(menu[i].buttonName=="添加"){
                //             this.disabledAdd = false;
                //         }
                //     }
                // }
            },
            rowClick(row){
                this.row = row;
                if(row.auditResult==0){
                    if(this.menuButtonList.indexOf("通过")!=-1){
                        this.disabledAdd =false;
                    }
                    if(this.menuButtonList.indexOf("不通过")!=-1){
                        this.disabledEdit =false;
                    }
                }else{
                    this.disabledAdd =true;
                    this.disabledEdit =true;
                }
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            toggleModalAdd:function(){
                this.$confirm('审核通过后将提交到财务代办，是否继续？', '提示', {
                    confirmButtonText: '通过',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.submit(1,'');
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            submit(auditResult,remarks){
                this.loading = true
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundAudit/Check",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        refundAuditCode:this.row.refundAuditCode,
                        auditResult:auditResult,
                        noPassCause:remarks
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        var message='操作成功！';
                        if(auditResult==1){
                            message='退费事项已提交到财务待办！'
                        }
                        this.$message.success(message)
                        this.getList();
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            
            toggleModalEdit:function(){
                this.$confirm('确认不通过, 是否继续?', '提示', {
                    confirmButtonText: '不通过',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.$prompt('请输入驳回备注', '备注', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputType:'textarea'
                        }).then(({ value }) => {
                            this.submit(2,value);
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '取消输入'
                            });       
                        });
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundAudit/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledAdd = true;
                    this.disabledEdit = true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: rgb(121, 187, 255);
        color:#fff;
    }
</style>
